__turbopack_context__.v({
  "contentWrapper": "Q2ZIlW_contentWrapper",
  "headingWrapper": "Q2ZIlW_headingWrapper",
});
